// extracted by mini-css-extract-plugin
export var collapsedSummary = "_r9-0";